// cp-db-app image build only (webpack.web.config.js aliases "date-fns/locale"
// here when CP_DB_APP_IMAGE_BUILD=1). The barrel re-exports every locale; the
// app imports only `hi` (src/screens/LGL/index.js, src/components/LGL/
// PreviousMonthStats.js). A locale imported from "date-fns/locale" that isn't
// re-exported here is undefined on web, so add it here too.
// date-fns v2: webpack resolves the per-locale package to its ESM build (the
// "module" field), so the locale is the default export; plain Node's CJS build
// exports the locale object itself.
const hi = require("date-fns/locale/hi");
exports.hi = hi.default || hi;
